import { Component, inject } from '@angular/core';
import { routes } from 'src/routes';
import { TaskToastService } from 'src/services';
import { PagesV2Module } from '@schenck/rotec-components';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslateDirective } from '@ngx-translate/core';

/**
 * Navigation component.
 */
@Component({
  selector: 'ma-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less'],
  imports: [PagesV2Module, RouterLinkActive, RouterLink, TranslateDirective],
})
export class PagesComponent {
  private readonly tastToastService = inject(TaskToastService);

  overviewLink = routes.overview.absoluteUrl;
  machineTasksLink = routes.machineTasks.absoluteUrl;
  machineHistoryLink = routes.machineHistory.absoluteUrl;
  toolingTasksLink = routes.toolingTasks.absoluteUrl;
  toolingHistoryLink = routes.toolingHistory.absoluteUrl;
}
